import { ConfirmationModal as BaseConfirmationModal } from '@echotex/business-modules';
import { ModalTypes } from '../../ConfirmationModal/components/InfoModal/IInfoModal';
import { IUserActivityModal } from './IUserActivityModal';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

export const UserActivityModal = ({ onCancel, onConfirm, onCrossBtnClick }: IUserActivityModal): JSX.Element => {
  // form state
  const handleModalConfirm = () => {
    onConfirm?.();
  };

  const handleModalClose = () => {
    onCancel?.();
  };

  return (
    <BaseConfirmationModal
      modalType={ModalTypes.Primary}
      primaryConfirmation={'Still with us? Extend your session to keep working.'}
      confirmButtonText={'Stay logged in'}
      cancelButtonText={'Log out'}
      onConfirm={handleModalConfirm}
      onClose={handleModalClose}
      onCrossBtnClick={onCrossBtnClick}
      showModalHeader={true}
      modalTitle={`Session timeout`}
      icon={<AccessTimeIcon />}
      iconColor='#FFA726'
    />
  );
};

export default UserActivityModal;
